import React, { ChangeEvent } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightAddon,
} from '@wegroup/design-system';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CoverageFormValues } from '../../../../../types/Form';

const AddInsuranceModalInsuranceFormInsuranceTax: React.FC = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<CoverageFormValues>();

  return (
    <FormControl isInvalid={!!errors?.insurance_tax_percentage}>
      <FormLabel>{t('INSURANCE-TAX')}</FormLabel>
      <Controller
        name="insurance_tax_percentage"
        control={control}
        render={({ field: { onChange, name, value, ...fieldProps } }) => {
          return (
            <InputGroup>
              <Input
                name={name}
                type="number"
                value={value || undefined}
                placeholder="0,00"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const _value = Number(e.currentTarget.value);
                  onChange(_value || null);
                }}
                {...fieldProps}
              />
              <InputRightAddon bg="white" color="text.gray">
                %
              </InputRightAddon>
            </InputGroup>
          );
        }}
      />
      {errors?.insurance_tax_percentage?.message && (
        <FormErrorMessage>
          {t(errors.insurance_tax_percentage.message)}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default AddInsuranceModalInsuranceFormInsuranceTax;
